import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import ChangeMobileNumberPopup from "../ChangeMobileNumberPopup";
import ChangeAlternateMobileNumberPopup from "../ChangeAlternateMobileNumberPopup";
import ChangeEditNamePopup from "../ChangeEditNamePopup";
import ChangeEmailAddressPopup from "../ChangeEmailAddressPopup";
import VerifyEmailAddressPopup from "../VerifyEmailAddressPopup";
import VerifyMobileNumberPopup from "../VerifyMobileNumberPopup";
import http from "../../api/http-request";
import Alert from "../common/Alert";
import {
  pageNotFound,getPhoneNumberFromFormattedString,somethingWentWrong, getLocalStorageValue, setLocalStorageValue, removeLocalStorageValue, removeAllStorageValues
} from "../../utils/common";
import { sanitizeUrl } from "@braintree/sanitize-url";
import queryString from "query-string";

class PersonalInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoutLink : ""
    };
  }

  componentDidMount() {
    this.state = {
      isLogoutLinkPresent : false
    };
    const goto = getLocalStorageValue("backTo");
    const params = queryString.parse(goto);
    if(params.logoutLink !== '' && params.logoutLink !== undefined && params.logoutLink !== null) {
      this.setState({
        isLogoutLinkPresent: true,
        logoutLink: params.logoutLink
       });
    }
  } 
  showHideMobileNumberPopup = (showHide) => {
    this.setState({
      showMobileNumberPopup: showHide
    });
  };
  showHideAlternateMobileNumberPopup = (showHide) => {
    this.setState({
      showAlternateMobileNumberPopup: showHide
    });
  };
  showHideVerifyMobileNumberPopup = (showHide) => {
    this.setState({
      showVerifyMobileNumberPopup: showHide
    });
  };
  showHideEditNamePopup = (showName) => {
       this.setState({
        showEditNamePopup: showName
       });
  };
  showHideEmailAddressPopup = (showEmail) => {
    this.setState({
      showEmailAddressPopup: showEmail
    });
};
showHideVerifyAddressPopup = (showEmail) => {
  this.setState({
    showVerifyAddressPopup: showEmail
  });
};

  onChangeMobileNumberHandler = (status) => {
    const alertText =
      status === "success"
        ? "pages.editNumberPopup.mobileChangeSuccessMsg"
        : "pages.editNumberPopup.mobileChangeErrorMsg";
    if (status === "success") {
      //Condition to check if it is updated
      if(!getLocalStorageValue("isProfileUpdated")) {  
        setLocalStorageValue("isProfileUpdated", true);
      }
      const { getUpdatedMobileNumber } = this.props;
      getUpdatedMobileNumber();

      if(this.state.isLogoutLinkPresent) {              
          this.onLogoutHandler();
      }
    }
    this.setState(
      {
        showMobileNumberPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };

  onChangeAlternateMobileNumberHandler = (status) => {
    const alertText =
      status === "success"
        ? "pages.editNumberPopup.mobileChangeSuccessMsg"
        : "pages.editNumberPopup.mobileChangeErrorMsg";
    if (status === "success") {
      const { getUpdatedAlternateMobileNumber } = this.props;
      getUpdatedAlternateMobileNumber();
      if(this.state.isLogoutLinkPresent) {              
            this.onLogoutHandler();
        }
    }
    this.setState(
      {
        showAlternateMobileNumberPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };

  onVerifyMobileNumberHandler= (status) => {
    const alertText =
      status === "success"
        ? "pages.editNumberPopup.verifyMobileChangeSuccessMsg"
        : "pages.editNumberPopup.mobileChangeErrorMsg";
    if (status === "success") {
      const { getVerifiedMobileNumber } = this.props;
      getVerifiedMobileNumber();
    }
    this.setState(
      {
        showVerifyMobileNumberPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };

  onChangeEmailAddressHandler = (status) => {
    const alertText =
      status === "success"
        ? "pages.editEmailAddressPopup.emailChangeSuccessMsg"
        : "pages.editEmailAddressPopup.emailChangeErrorMsg";
    if (status === "success") {
     //Condition to check if it is updated
     if(!getLocalStorageValue("isProfileUpdated")) {  
      setLocalStorageValue("isProfileUpdated", true);
    }
      if(this.state.isLogoutLinkPresent) {              
          this.onLogoutHandler();
      }
      const { getUpdatedName } = this.props;
      getUpdatedName();
    }
    this.setState(
      {
        showEmailAddressPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };

  onVerifyEmailAddressHandler = (status) => {
    const alertText =
      status === "success"
        ? "pages.editEmailAddressPopup.emailVerifySuccessMsg"
        : "pages.editEmailAddressPopup.emailChangeErrorMsg";
    if (status === "success") {
      const { getUpdatedName } = this.props;
      getUpdatedName();
    }
    this.setState(
      {
        showVerifyAddressPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };

  onChangeEditNameHandler = (status) => {
        const alertText =
          status === "success"
            ? "pages.profile.langProfileChangeSuccessMsg"
            : "pages.editNamePopup.editNameErrorMsg";
        if (status === "success") {
          //Condition to check if it is updated
          if(!getLocalStorageValue("isProfileUpdated")) {  
            setLocalStorageValue("isProfileUpdated", true);
          }
          if(this.state.isLogoutLinkPresent) {              
            this.onLogoutHandler();
          }
          const { getUpdatedName } = this.props;
          getUpdatedName();
        }
        
        this.setState(
          ({
            showEditNamePopup: false,
            alertStatus: status,
            alertText
          }),
          () => {
            setTimeout(() => {
              this.setState({
                alertText: ""
              });
            }, 5000);
          }
        );
    };

  onLogoutHandler = () => {
        removeAllStorageValues();
        removeLocalStorageValue("isUserLogin");
        if (getLocalStorageValue("dataStoreToken")) {
          removeLocalStorageValue("dataStoreToken");
        }
        if (getLocalStorageValue("authToken")) {
          removeLocalStorageValue("authToken");
        }
      const locationUrl = window.location.origin;
      let logOutUrl;
      if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
        logOutUrl = `/openam/IDPSloInit?metaAlias=/BOSCitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState=` + this.state.logoutLink;
      } else {
        logOutUrl = `/IDPSloInit?metaAlias=/boscitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState=` + this.state.logoutLink;
      }
      window.location.replace(sanitizeUrl(`${locationUrl}${logOutUrl}`));
    }

  verifyEmail = () => {
    this.getToken();
  };

  getToken = () => {
    http(
      {
        url: "selfservice/resendVerificationEmail?_action=submitRequirements",
        data: { input: { input: {} } },
        method: "POST"
      },
      {
        "X-OpenIDM-NoSession": true,
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous"
      }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data.type === 'userQuery') {
        const {
          userData: { mail }
        } = this.props;
        http(
          {
            url:
              "selfservice/resendVerificationEmail?_action=submitRequirements",
            data: {
              input: { queryFilter: `mail eq "${mail}"` },
              token: res.data.token
            },
            method: "POST"
          },
          {
            "X-OpenIDM-NoSession": true,
            "X-OpenIDM-Username": "anonymous",
            "X-OpenIDM-Password": "anonymous"
          }
        ).then((response) => {
          if (response.status === 200 && response.data && response.data.type === 'CTEmailValidation') {
            this.showApiStatus("success");
          } else {
            this.showApiStatus("error");
          }
        });
      } 
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {
        this.showApiStatus("error");
      }
    });
  };

  getOtp = (telephoneNumber) => {
    const dataStoreToken = localStorage.getItem("authToken");
    const bearer = 'Bearer ';
    http(
      {
        url: "endpoint/phoneNoVerification?_action=generateOtp",
        method: "POST",
        data: {
          phoneNumber: getPhoneNumberFromFormattedString(
            telephoneNumber
          )
        }
      },
      {
        "X-OpenIDM-OAuth-Login": true,
        "X-Requested-With": "XMLHttpRequest",
        Authorization: `${bearer}${dataStoreToken}`
      }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data.code === 200) {
        this.showHideVerifyMobileNumberPopup(true);
      }
      else if(res.status === 400 && res.data.code === 400 && res.data.message === 'INVALID_NUMBER'){
        this.showPhoneError("error",res.data.message);
      }
      else if(res.status === 400 && res.data.code === 400 && res.data.message === "MAX_RESEND_EXCEEDED"){
        this.showPhoneError("error",res.data.message);
      }
      else if(res.status === 400 && res.data.code === 400 && res.data.message === "TWILIO_ERROR"){
        this.showPhoneError("error",res.data.message);
      }
      else if(res.status === 400 && res.data.code === 400 && res.data.message === "SMTP_ERROR"){
        this.showPhoneError("error",res.data.message);
      }
      else {
        somethingWentWrong();
      }
    });
  }


  getEmailOtp = (mail) => {
    const dataStoreToken = localStorage.getItem("authToken");
    const bearer = 'Bearer ';
   
    http(
      {
        url: "endpoint/emailVerification?_action=generateOtp",
        method: "POST",
        data: {
          mail: mail
        }
      },
      {
        "X-OpenIDM-OAuth-Login": true,
        "X-Requested-With": "XMLHttpRequest",
        Authorization: `${bearer}${dataStoreToken}`
      }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data.code === 200) {
        this.showHideVerifyAddressPopup(true);
      } else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      } 
      else if(res.status === 502 && res.data.code === 502 && res.data.message === "SMTP_ERROR"){
        this.showEmailError("error",res.data.message);
      }
    });
  };



  showApiStatus = (status) => {
    const alertText =
      status === "success"
        ? "pages.profile.verifyEmailSuccessMessage"
        : "pages.profile.verifyEmailErrorMessage";
    this.setState(
      {
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };
  showPhoneError = (status,message) => {
    let alertText = "";
    if(message === 'INVALID_NUMBER'){
     alertText = "pages.profile.verifyPhoneNumberError"
    }
    else if(message === 'MAX_RESEND_EXCEEDED'){
      alertText = "common.errors.maxResendAttempt"
    }
    else if(message === 'TWILIO_ERROR'){
      alertText = "common.errors.twilioError"
    }
    else if(message === 'SMTP_ERROR'){
      alertText = "pages.editEmailAddressPopup.smtpError"
    }
    
    this.setState(
      {
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };


  onErrorHandler = (status,message) => {
    let alertText = "";
    if(message === 'SMTP_ERROR'){
      alertText = "pages.editEmailAddressPopup.smtpError";
    }
    else if(message === 'MAX_RESEND_EXCEEDED'){
      alertText = "common.errors.maxResendAttempt";
    }
    else if(message === 'MAX_RETRY_EXCEEDED'){
      alertText = "pages.forgotUserName.maxVerifyAttempt";
    }
    else if(message === 'TWILIO_ERROR'){
      alertText = "common.errors.twilioError"
    }
    if(status === 'error'){
      this.setState(
        {
          alertStatus: status,
          showEmailAddressPopup: false,
          showMobileNumberPopup:false,
          showAlternateMobileNumberPopup:false,
          showVerifyMobileNumberPopup:false,
          showVerifyAddressPopup:false,
          alertText
        },
        () => {
          setTimeout(() => {
            this.setState({
              alertText: ""
            });
          }, 5000);
        }
      );
      window.scrollTo({
        behavior: "smooth",
        top: 0
      });
    }
  };

  showEmailError = (status,message) => {
    let alertText = "";
    if(message === 'SMTP_ERROR'){
      alertText = "pages.editEmailAddressPopup.smtpError"
    }
    
    this.setState(
      {
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };

  render() {
    const { t, userData,userId } = this.props;
    const { showMobileNumberPopup,showAlternateMobileNumberPopup,showVerifyMobileNumberPopup,showEditNamePopup,showEmailAddressPopup,showVerifyAddressPopup, alertStatus, alertText, isLogoutLinkPresent, logoutLink } = this.state;

    return (
      <>
        {showMobileNumberPopup && (
          <ChangeMobileNumberPopup
            onClose={() => this.showHideMobileNumberPopup(false)}
            onChangeMobileNumberHandler={this.onChangeMobileNumberHandler}
            telephoneNumber={userData.telephoneNumber}
            onErrorHandler={this.onErrorHandler}
            isLogoutLinkPresent = {isLogoutLinkPresent}
          />
        )}
        {showAlternateMobileNumberPopup && (
          <ChangeAlternateMobileNumberPopup
            onClose={() => this.showHideAlternateMobileNumberPopup(false)}
            onChangeAlternateMobileNumberHandler={this.onChangeAlternateMobileNumberHandler}
            alternatecontactNumber={userData.alternatecontactNumber}
            onErrorHandler={this.onErrorHandler}
            userId={userId}
            isLogoutLinkPresent = {isLogoutLinkPresent}
          />
        )}
        {showVerifyMobileNumberPopup && (
          <VerifyMobileNumberPopup
            onClose={() => this.showHideVerifyMobileNumberPopup(false)}
            onVerifyMobileNumberHandler={this.onVerifyMobileNumberHandler}
            telephoneNumber={userData.telephoneNumber}
            onErrorHandler={this.onErrorHandler}
          />
        )}
        {showEditNamePopup && (
          <ChangeEditNamePopup
            onClose={() => this.showHideEditNamePopup(false)}
            onChangeEditNameHandler={this.onChangeEditNameHandler}
            givenName={userData.givenName}
            sn={userData.sn}
            userId={userId}
            middleName={userData.middleName}
            title={userData.title}
            suffix={userData.suffix}
            isLogoutLinkPresent = {isLogoutLinkPresent}
          />
        )}
        {showEmailAddressPopup && (
          <ChangeEmailAddressPopup
            onClose={() => this.showHideEmailAddressPopup(false)}
            onChangeEmailAddressHandler={this.onChangeEmailAddressHandler}
            onErrorHandler={this.onErrorHandler}
            mail={userData.mail}
            isLogoutLinkPresent = {isLogoutLinkPresent}
          />
        )}
        {showVerifyAddressPopup && (
          <VerifyEmailAddressPopup
            onClose={() => this.showHideVerifyAddressPopup(false)}
            onVerifyEmailAddressHandler={this.onVerifyEmailAddressHandler}
            mail={userData.mail}
            onErrorHandler={this.onErrorHandler}
          />
        )}
        {alertText && (
          <Alert
            alertText={alertText}
            className={alertStatus}
            onAlertClose={() => {
              this.setState({
                alertText: ""
              });
            }}
          />
        )}
        <div className="section-entry">
          <h2 className="page-heading">
            {t("pages.profile.personalInformation")}
          </h2>
          <p className="page-desc">
            {t("pages.profile.personalInformationDesc")}
          </p>
          <Row noGutters className="cards">
            <Col>
              <h3 className="cards__title">{t("pages.profile.profile")}</h3>
              <div className="cards__box">
                <Row noGutters className="cards__box-row user-icon black">
                  <Col xs={{ span: 4 }} className="name-section">
                    <p className="cards__box-row-title">
                      {t("pages.profile.name")}
                    </p>
                  </Col>
                  <Col xs={{ span: 6 }} lg={{span:4}}>
                    <p className="cards__box-row-text text-name">
                      {`${userData.title === null ? '' : userData.title} ${userData.givenName} ${userData.middleName === null ? '' : userData.middleName} ${userData.sn} ${userData.suffix === null ? '': userData.suffix}`}
                    </p>
                  </Col>
                  <Col xs={{ span: 2 }} lg={{span:4}}>
                     <p
                        role="button"
                        tabIndex={0}
                        className="cards__box-row-link"
                        onClick={() => this.showHideEditNamePopup(true)}
                        onKeyPress={() => this.showHideEditNamePopup(true)}
                        aria-label={t("pages.profile.ariaEditName")}
                      >
                        {t("pages.profile.editEmailAddress")}
                      </p>
                  </Col>
                </Row>
                <Row noGutters className="cards__box-row email-icon black">
                  <Col xs={{ span: 4 }}>
                    <p className="cards__box-row-title">
                      {t("pages.profile.userName")}
                    </p>
                  </Col>
                  <Col xs={{ span: 6 }}>
                    <p className="cards__box-row-text">{userData.userName}</p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row noGutters className="cards">
            <Col>
              <h3 className="cards__title mt-4">
                {t("pages.profile.contactInformation")}
              </h3>
              <div className="cards__box">
                  <Row noGutters className="cards__box-row mobile-icon bold">
                    <Col xs={{ span: 4 }} className="email-section">
                      <p className="cards__box-row-title">
                        <span className="full">{t("pages.profile.mobilePhone")}</span>
                        <span className="short">{t("pages.profile.shortMobile")}</span>
                      </p>
                    </Col>
                    <Col xs={{ span: 6 }} lg={{span:4}} className="email-section"> 
                    <p
                      className={`cards__box-row-text email-address ${
                        userData.phoneValidated && userData.phoneValidated.toLowerCase() === "true" &&
                        "email-tick"
                      }`}
                    >
                      {userData.telephoneNumber
                          ? userData.telephoneNumber
                          : t("pages.profile.none")}
                    </p>
                    </Col>
                    <Col xs={{ span: 2 }} lg={{span:4}}>
                    <Row className="verify-email align-items-center">
                      {(userData.phoneValidated === 'false' || userData.phoneValidated === null) && userData.telephoneNumber && (
                        <p
                        role="button"
                        tabIndex={0}
                        className="cards__box-row-link"
                        onClick={() => this.showHideVerifyMobileNumberPopup(true)}
                        onKeyPress={() => this.showHideVerifyMobileNumberPopup(true)}
                      >
                        {t("pages.profile.verifyPhone")} <span>|</span>
                      </p>
                      )}
                        <p
                        role="button"
                        tabIndex={0}
                        className="cards__box-row-link"
                        onClick={() => this.showHideMobileNumberPopup(true)}
                        onKeyPress={() => this.showHideMobileNumberPopup(true)}
                        aria-label={userData.telephoneNumber ? t("pages.profile.ariaAddMobileNumber") : t("pages.profile.ariaEditMobileNumber")}
                        >
                        {userData.telephoneNumber
                          ? t("pages.profile.editNumber")
                          : t("pages.profile.addPhoneNumber")}
                        </p>
                        {!userData.telephoneNumber && (
                         <span>{t("pages.profile.optional")}</span>
                        )}
                        </Row>
                    </Col>
                  </Row>
                  <Row noGutters className="cards__box-row alternate-mobile-icon bold">
                    <Col xs={{ span: 4 }} className="email-section">
                      <p className="cards__box-row-title">
                        <span className="full">{t("pages.profile.alternateContactNumber")}</span>
                        <span className="short">{t("pages.profile.shortAlternate")}</span>
                      </p>
                    </Col>
                    <Col xs={{ span: 6 }} lg={{span:4}} className="email-section"> 
                    <p className="cards__box-row-text email-address">
                      {userData.alternatecontactNumber
                          ? userData.alternatecontactNumber
                          : t("pages.profile.none")}
                    </p>
                    </Col>
                    <Col xs={{ span: 2 }} lg={{span:4}}>
                      <Row className="verify-email align-items-center">
                          <p
                          role="button"
                          tabIndex={0}
                          className="cards__box-row-link"
                          onClick={() => this.showHideAlternateMobileNumberPopup(true)}
                          onKeyPress={() => this.showHideAlternateMobileNumberPopup(true)}
                          aria-label={userData.alternatecontactNumber ? t("pages.profile.editNumber") : t("pages.profile.ariaAddAlternate")}
                          >
                          {userData.alternatecontactNumber
                            ? t("pages.profile.editNumber")
                            : t("pages.profile.addPhoneNumber")}
                          </p>
                          {!userData.alternatecontactNumber && (
                            <span>{t("pages.profile.optional")}</span>
                          )}
                        </Row>
                    </Col>
                  </Row>
                <Row noGutters className="cards__box-row email-icon bold">
                  <Col xs={{ span: 4 }} className="email-section">
                    <p className="cards__box-row-title">
                    <span className="full">{t("pages.profile.emailAddress")}</span>
                    <span className="short">{t("pages.profile.shortEmail")}</span>
                    </p>
                  </Col>
                  <Col xs={{ span: 6 }} lg={{span:4}} className="email-section">
                    <p
                      className={`cards__box-row-text email-address ${
                        userData.emailValidated.toLowerCase() === "true" &&
                        "email-tick"
                      }`}
                    >
                      {userData.mail}
                    </p>
                  </Col>
                  <Col xs={{ span: 2 }} lg={{span:4}} className="email-section">
                    <Row className="verify-email">
                     {userData.emailValidated.toLowerCase() === "false" && (
                      <p
                        className="cards__box-row-link"
                        role="button"
                        tabIndex={0}
                        // onClick={() => this.showHideVerifyAddressPopup(true)}
                        // onKeyPress={() => this.showHideVerifyAddressPopup(true)}
                        onClick={() => this.showHideVerifyAddressPopup(true)}
                        onKeyPress={()=> this.showHideVerifyAddressPopup(true)}
                      >
                        {t("pages.profile.verifyEmail")} <span>|</span>
                      </p> 
                    )}
                    <p
                        className="cards__box-row-link"
                        role="button"
                        tabIndex={0}
                        onClick={() => this.showHideEmailAddressPopup(true)}
                        onKeyPress={() => this.showHideEmailAddressPopup(true)}
                        aria-label={t("pages.profile.ariaEditEmail")}
                      >
                        {t("pages.profile.editEmailAddress")}
                      </p>
                    </Row>
                  
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

PersonalInformation.propTypes = {
  t: PropTypes.func.isRequired,
  userData: PropTypes.object,
  getUpdatedMobileNumber: PropTypes.func.isRequired,
  getUpdatedAlternateMobileNumber: PropTypes.func.isRequired,
  getVerifiedMobileNumber:PropTypes.func.isRequired,
  getUpdatedName: PropTypes.func.isRequired
};
PersonalInformation.defaultProps = {
  userData: {
    userName: "",
    mail: "",
    telephoneNumber: "",
    alternatecontactNumber: "",
    givenName: "",
    sn: "",
    middleName:"",
    title:"",
    suffix:"",
    emailValidated: false,
    phoneValidated:false
  }
};
export default withTranslation()(PersonalInformation);
